import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSalling = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 128 128",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M108.91 24.974c6.501 0 9.119 2.784 9.119 2.784L128 13.551S121.474 8 109.347 8 84.39 16.873 78.994 32.543C73.597 48.21 63.737 79.456 63.737 79.456s-7.557 22.772-27.146 22.772c-17.02 0-26.354-9.52-26.354-9.52L0 105.217S12.344 119 34.261 119s36.509-6.748 46.612-39.345C90.975 47.06 95.556 36.94 95.556 36.94s4.288-11.966 13.354-11.966"
	})
});
export default SvgIconSalling;
